import type { WalletProvider } from '@/extensions/snk/lib/device-utils';
import { cn } from '@/lib/utils';
import { DownloadApp, LinkColumns, NewsletterForm, PaymentMethods, SocialMediaIcons } from './ui';
import { Separator } from '@/components/ui/separator';
import type { ComponentWithComponentData } from '@/lib/page-designer/component-loader.server';

export interface GlobalFooterProps {
    globalFooter: Promise<ComponentWithComponentData | null>;
    appStorePlatform: WalletProvider;
    className?: string;
}

export const GlobalFooter = ({ globalFooter, appStorePlatform, className }: GlobalFooterProps) => {
    const borderClasses = 'border-primary-foreground border-t';
    const gridSeparatorClasses = `${borderClasses} md:hidden`;

    return (
        <footer data-slot="global-footer" className={cn('mt-auto bg-primary', className)}>
            <div className="flex flex-col px-4 py-6 md:px-12 md:py-8">
                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 pb-6 md:pb-8">
                    <NewsletterForm />
                    <Separator className={gridSeparatorClasses} />
                    <DownloadApp appStorePlatform={appStorePlatform} />
                    <Separator className={gridSeparatorClasses} />
                    <SocialMediaIcons globalFooter={globalFooter} />
                    <Separator className={gridSeparatorClasses} />
                    <PaymentMethods globalFooter={globalFooter} />
                </div>

                <Separator className={borderClasses} />
                <LinkColumns globalFooter={globalFooter} />
            </div>
        </footer>
    );
};
